module.exports = __webpack_public_path__ + "b7d32a745bffdda5888c46c6ba461bdd.svg";